import React, { useEffect, useRef } from 'react';
import { cx } from '../cx';

// D-09 §15.2 — Checkbox (.chk > input[checkbox] + label)
// indeterminate: 전체선택에서 일부만 선택된 "─" 상태 (DOM 프로퍼티라 prop→ref 반영)
// bare: 자체 <label> 래핑 없이 <input>만 렌더 — 행 전체가 이미 label인 선택행용(label 중첩 방지)
export interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: React.ReactNode;
  indeterminate?: boolean;
  bare?: boolean;
  /** 체크 색 개별 지정(예: 공종색 '#1f6feb' · 'var(--...)'). 내부에서 CSS 변수 --chk-color 로 설정 — 미지정 시 --gt-primary */
  color?: string;
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  { label, indeterminate = false, bare = false, color, className = '', style, ...props },
  ref,
) {
  const innerRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (innerRef.current) innerRef.current.indeterminate = indeterminate;
  }, [indeterminate]);

  const setRefs = (el: HTMLInputElement | null) => {
    innerRef.current = el;
    if (typeof ref === 'function') ref(el);
    else if (ref) ref.current = el;
  };

  const colorStyle = color
    ? ({ ...style, ['--chk-color' as string]: color } as React.CSSProperties)
    : style;

  if (bare) {
    return (
      <input
        type="checkbox"
        ref={setRefs}
        className={cx('chk-bare', className)}
        style={colorStyle}
        {...props}
      />
    );
  }

  return (
    <label className={cx('chk', className)}>
      <input type="checkbox" ref={setRefs} style={colorStyle} {...props} /> {label}
    </label>
  );
});
